module.exports = __webpack_public_path__ + "img/delivery-success.061aedab.svg";